import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Panel } from "../../../panel";
import { WizardStepper } from "./WizardStepper";
import { FormErrors } from "../../../components/FormErrors";
import { useStyles, actionsTheme, wizardSummaryHeaderTheme, wizardSummaryTheme } from "./styles";
import FormStatus from "../../../components/FormStatus";
import { ThemeProvider } from "@material-ui/core/styles";
import { useSticky } from "../../useSticky";
import { usePageState } from "../../../PageContext";
import { addRegisteredLayout } from "../layoutDescriptions";
import clsx from "clsx";
const panelSettings = {
    summaryHeader: {
        defaultOptions: {
            literal: true
        }
    },
    main: {},
    summary: {
        editableOptions: {
            hideForMobile: true
        },
        defaultOptions: {
            literal: true
        }
    },
    actions: {
        defaultOptions: {
            literal: true
        }
    }
};
addRegisteredLayout({
    name: "WizardMain",
    displayName: "WizardMain",
    panels: panelSettings
});
export const WizardMain = (props) => {
    return (_jsx(Grid, { container: true, spacing: 2, children: _jsx(WizardMainAndSummary, { ...props }) }));
};
export const WizardMainAndSummary = (props) => {
    const { panels, navigationButtonsSummary, stepper } = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down("xs"));
    const { lastStep } = usePageState();
    const { getStickyProps } = useSticky();
    const { main, summary, summaryHeader, actions } = panels;
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsxs(Grid, { item: true, xs: 12, children: [!stepper && lastStep !== 0 && (_jsx(WizardStepper, { className: clsx({
                                        [classes.rounded]: !main.square
                                    }), elevation: main.elevation })), _jsx(FormStatus, { className: clsx(classes.errorSection, {
                                        [classes.rounded]: !main.square
                                    }), elevation: main.elevation }), _jsx(FormErrors, { className: clsx(classes.errorSection, {
                                        [classes.rounded]: !main.square
                                    }), elevation: main.elevation }), main && (_jsx("div", { className: classes.panelRoot, children: _jsx(Panel, { ...main, className: clsx({
                                            [classes.panelRounded]: !main.square
                                        }) }) }))] }), _jsx(Grid, { item: true, xs: 12, children: actions && !navigationButtonsSummary && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { className: classes.actions, justifyContent: xsDown &&
                                        (actions.sections || []).flatMap(s => s.fields).length > 1
                                        ? "space-between"
                                        : "flex-end", transparent: true, disableExpansion: true, disableTabs: true, fullWidth: true, ...actions }) })) })] }) }), (summaryHeader || summary) && (_jsxs(Grid, { item: true, xs: 12, md: 4, children: [_jsxs(Grid, { container: true, ...getStickyProps(), spacing: 3, direction: "column", children: [summaryHeader && (_jsx(Grid, { item: true, className: classes.panelGrid, children: _jsx(ThemeProvider, { theme: wizardSummaryHeaderTheme, children: _jsx(Panel, { className: classes.summaryHeader, fullWidth: true, disableExpansion: true, disableTabs: true, ...summaryHeader }) }) })), summary && (_jsx(Grid, { item: true, className: classes.panelGrid, children: _jsx(ThemeProvider, { theme: wizardSummaryTheme, children: _jsx(Panel, { ...summary }) }) }))] }), actions && navigationButtonsSummary && (_jsx(Grid, { container: true, spacing: 0, ...getStickyProps(), direction: "column", children: _jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { className: clsx(classes.actions, classes.stickyActions), justifyContent: xsDown &&
                                    (actions.sections || []).flatMap(s => s.fields).length > 1
                                    ? "space-between"
                                    : "flex-start", transparent: true, wrap: "nowrap", disableExpansion: true, disableTabs: true, fullWidth: true, ...actions }) }) }))] }))] }));
};
WizardMainAndSummary.displayName = "DployFormWizardMain";
//# sourceMappingURL=WizardMain.js.map